module.exports = __webpack_public_path__ + "static/media/select_icon.46889bf7.svg";